module.exports = __webpack_public_path__ + "img/clients-01.17294b0c.svg";